<template>
  <div class="gateWay">
    <!-- <div class="back" @click="back()"></div> -->
    <div class="wayKuang1" v-show="way1">
      <div>{{this.wayData.Name}}</div>
      <div>传输速率：{{this.wayData.Efficiency1}}</div>
    </div>

    <div class="wayKuang2" v-show="way2">
      <div>{{this.wayData.Name}}</div>
      <div>传输速率：{{this.wayData.Efficiency1}}</div>
    </div>
  </div>
</template>

<script>
//import { getEdgeGateway } from "../api/api";
export default {
  data() {
    return {
      wayData: "", //网关数据
      wayLeft:'',
      wayTop:'',
      way1:false,
      way2:false
    };
  },
  props: ["needWayName"],
  mounted() {
    this.EdgeGateway(this.needWayName);
  },
  methods: {
    EdgeGateway(needWayName) {
      // console.log(needWayName, "wnagguan");
      if (needWayName == "b7") {
//      let param = {
//        gatewayId: 1,
//      };
//      console.log(param);
//      getEdgeGateway(param).then((res) => {
//         console.log(res, "边缘网关1");
          this.wayData = {"Efficiency1": "54%",
"Name": "北环网关1"};
//      });
        this.way2 = true;
      } else if(needWayName == "bianyuanwangguan1_5" || needWayName == "bianyuanwangguan1_1" ){
//      let param = {
//        gatewayId: 2,
//      };
//      console.log(param);
//      getEdgeGateway(param).then((res) => {
//         console.log(res, "边缘网关2");
          this.wayData = {"Efficiency1": "30%",
"Name": "蔡家网关2"};
//      });
        this.way1 = true;
      }
    },
    // back() {
    //   this.$router.push({
    //     path: "/",
    //   });
    //    document.getElementById("iframe").contentWindow.MMAPI.show1(0);
    // //    document.getElementById('iframe').contentWindow.MMAPI.show(true)
    //  },
  },
  destroyed(){
    this.way1 = false;
    this.way2 = false;
  }
};
</script>

<style scoped>
.gateWay {
  width: 100%;
  height: 100%;
  position: absolute;
  /* pointer-events: none; */
  /* background: rgba(0, 0, 0,0.8); */
}
.back {
  width: 1.8vw;
  height: 3.6vh;
  position: absolute;
  background: url("../assets/img/back.png") no-repeat;
  right: 2.1vw;
  top: 8vh;
  cursor: pointer;
  z-index: 10;
}
.wayKuang1 {
  width: 222px;
  height: 162px;
  position: absolute;
  background: url('../assets/img/getWay-kuang.png') no-repeat;
  background-size:100% 100% ;
  left: 12%;
  top: 12%;


}

.wayKuang2 {
  width: 222px;
  height: 162px;
  position: absolute;
  background: url('../assets/img/getWay-kuang.png') no-repeat;
  background-size:100% 100% ;
  right: 25%;
  top: 22%;

}
.wayKuang1 div {
  width: 100%;
  height: 24px;
  color: white;
  margin-top: 1vh;
}

.wayKuang2 div{
  width: 100%;
  height: 24px;
  color: white;
   margin-top: 1vh;
}
</style>
